import type { ReactNode } from "react";

export interface TooltipRow {
  name: string;
  value: string;
  color?: string;
}

/**
 * Positioned readout inside a `.viz-chart` container. Values lead, names
 * follow; series are keyed with a short line stroke, never a filled box.
 * All text is inserted as React text nodes (never innerHTML).
 */
export function ChartTooltip({ x, y, head, rows, width }: { x: number; y: number; head?: ReactNode; rows: TooltipRow[]; width: number }) {
  const flip = x > width * 0.65;
  return (
    <div className="viz-tooltip" role="status" style={{ left: flip ? undefined : x + 12, right: flip ? width - x + 12 : undefined, top: Math.max(0, y - 8) }}>
      {head !== undefined && <div className="t-head">{head}</div>}
      {rows.map((r) => (
        <div className="t-row" key={r.name}>
          {r.color && <i style={{ background: r.color }} aria-hidden="true" />}
          <span className="t-name">{r.name}</span>
          <strong>{r.value}</strong>
        </div>
      ))}
    </div>
  );
}
